import { z } from 'zod';

import { translate } from '@wecasa/i18n';

import { EMAIL_REGEX } from './email';

const t = translate('inputs');

export const emailRegexp: Record<string, RegExp> = {
  // too short if either the local part OR the domain label before the dot is 1 char
  tooShort: /^(?:\S{1}@\S+\.\S+|\S+@\S{1}\.\S+)/,
  default: EMAIL_REGEX,
};

// here we verify if the email is set and also if it is valid
export const emailSchema = z.string().superRefine((value, ctx) => {
  if (value.length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('.email.errors.required'),
    });
  } else if (emailRegexp.tooShort.test(value)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('.email.errors.too_short'),
    });
  } else if (!emailRegexp.default.test(value)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('.email.errors.invalid'),
    });
  }
});
